__turbopack_context__.v({
  "default": "radio-group-module-scss-module__LsFWFW__default",
  "description": "radio-group-module-scss-module__LsFWFW__description",
  "destructive": "radio-group-module-scss-module__LsFWFW__destructive",
  "disabled": "radio-group-module-scss-module__LsFWFW__disabled",
  "field": "radio-group-module-scss-module__LsFWFW__field",
  "indicator": "radio-group-module-scss-module__LsFWFW__indicator",
  "item": "radio-group-module-scss-module__LsFWFW__item",
  "item_wrapper": "radio-group-module-scss-module__LsFWFW__item_wrapper",
  "label": "radio-group-module-scss-module__LsFWFW__label",
  "label_wrapper": "radio-group-module-scss-module__LsFWFW__label_wrapper",
  "root": "radio-group-module-scss-module__LsFWFW__root",
  "success": "radio-group-module-scss-module__LsFWFW__success",
  "warning": "radio-group-module-scss-module__LsFWFW__warning",
});
